import { makeStyles } from "tss-react/mui";

interface IParams {
    isMobile: boolean;
    hasBackButton?: boolean;
    hasSubtitle?: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => {
    const { isMobile, hasBackButton, hasSubtitle } = props;

    return {
        root: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            gap: theme.spacing(3),
            marginBottom: theme.spacing(5),
            alignItems: isMobile && hasBackButton ? "flex-start" : "center",
        },
        button: {
            position: "absolute",
            transform: "translateY(-50%)",
            top: hasSubtitle ? "25%" : "50%",
            left: 0,
            alignItems: "center",
        },
        icon: {
            fontSize: theme.typography.h4.fontSize,
        },
        heading: {
            textAlign: isMobile && hasBackButton ? "start" : "center",
            paddingLeft: isMobile && hasBackButton ? theme.spacing(10) : 0,
        },
    };
});
